import { RootState } from "rootReducer";

export const featureFlags = (state: RootState) => state.featureFlags.list;
